<template>
  <section class="content">
    <br/>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-key mr-5"></i>{{ 'sales_discounts' | translate }}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="table-responsive">
                <template>
                  <hr/>
                  <b-table :fields="fields" :items="Cfees">
                    <template v-slot:head(sales_channel)="data">
                      <span>{{ 'marketplace' | translate }}</span>
                    </template>
                    <template v-slot:head(type)="data">
                      <span>{{ 'fee_order_type' | translate }}</span>
                    </template>
                    <template v-slot:head(delivery_country)="data">
                      <span>{{ 'delivery_country' | translate }}</span>
                    </template>
                    <template v-slot:head(mp_costs_step_1)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(mp_costs_step_2)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(mp_costs_step_3)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(mp_costs_step_4)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(mp_costs_step_default)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(mp_return_costs)="data">
                      <span>{{ 'return_fees' | translate }}</span>
                    <br/>
                      <small class="text-muted"><a class="ml-5" data-toggle="modal" data-target="#amazon-fees-modal">Info<i class="fa fa-info-circle ml-5"></i></a></small>
                    </template>
                    <template v-slot:head(mp_payment_costs)="data">
                      <span>
                               {{ 'processing_fee' | translate }} <br/>
                      </span>
                    </template>
                    <template v-slot:head(valid_from)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <div slot="cell(sales_channel)" slot-scope="data">
                      <span>{{ data.item.sales_channel.name | translate}}</span>
                    </div>
                    <div slot="cell(delivery_country)" slot-scope="data">
                      <span>{{ data.item.country }}</span>
                    </div>
                    <div slot="cell(type)" slot-scope="data">
                      <span>{{ data.item.order_type.split('_')[0]}}</span>
                    </div>
                    <div slot="cell(mp_costs_step_1)" slot-scope="data">
                      <span v-if="data.item.mp_costs_step_1 > 0">
                        {{data.item.mp_costs_step_1 | percentage}}
                      </span>
                      <span v-else >---</span>
                    </div>
                    <div slot="cell(mp_costs_step_2)" slot-scope="data">
                      <span v-if="data.item.mp_costs_step_2 > 0">
                        {{data.item.mp_costs_step_2 | percentage}}
                      </span>
                      <span v-else >---</span>
                    </div>
                    <div slot="cell(mp_costs_step_3)" slot-scope="data">
                      <span v-if="data.item.mp_costs_step_3 > 0">
                        {{ data.item.mp_costs_step_3 | percentage }}
                      </span>
                      <span v-else >---</span>
                    </div>
                    <div slot="cell(mp_costs_step_4)" slot-scope="data">
                      <span v-if="data.item.mp_costs_step_4 > 0">
                        {{ data.item.mp_costs_step_4 | percentage}}
                      </span>
                      <span v-else >---</span>
                    </div>
                    <div slot="cell(mp_costs_step_default)" slot-scope="data">
                      <span v-if="data.item.mp_costs_step_default > 0">
                        {{data.item.mp_costs_step_default | percentage}}
                      </span>
                      <span v-else >---</span>
                    </div>
                    <div slot="cell(mp_return_costs)" slot-scope="data">
                      <span v-if="data.item.type !== 'amazon'">
                        {{data.item.mp_costs_step_default | fieldNotInUse}}
                      </span>
                      <span v-else >{{data.item.mp_return_costs | percentage}}</span>
                    </div>
                    <div slot="cell(mp_payment_costs)" slot-scope="data">
                      <span v-if="data.item.type !== 'ebay'">
                        {{data.item.mp_payment_costs | fieldNotInUse}}
                      </span>
                      <span v-else >{{data.item.mp_payment_costs | currency}}</span>
                    </div>
                    <div slot="cell(valid_from)" slot-scope="data">
                      <template v-if="data.item.is_future">
                        <span style="color: #E08E0B;">{{data.item.valid_from | orderDateReverse(false) }}</span>
                      </template>
                      <template v-else>
                        <span>{{data.item.valid_from | orderDateReverse(false) }}</span>
                      </template>
                    </div>
                  </b-table>
                </template>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12  col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-key mr-5"></i>{{'transaction_fees' | translate}}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                </div>
              </div>
              <div class="col-xs-12">
                <div class="table-responsive">
                <template>
                  <hr/>
                  <b-table :fields="anwrFields" :items="Cfees">
                    <template v-slot:head(sales_channel)="data">
                      <span>{{ 'marketplace' | translate }}</span>
                    </template>
                    <template v-slot:head(type)="data">
                      <span>{{ 'fee_order_type' | translate }}</span>
                    </template>
                    <template v-slot:head(delivery_country)="data">
                      <span>{{ 'delivery_country' | translate }}</span>
                    </template>
                    <template v-slot:head(anwr_trans_costs_step_1)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(anwr_trans_costs_step_2)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(anwr_return_costs_step_1)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(anwr_return_costs_step_2)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <template v-slot:head(valid_from)="data">
                      <span>{{ data.column | translate }}</span>
                    </template>
                    <div slot="cell(sales_channel)" slot-scope="data">
                      <span>{{ data.item.sales_channel.name | translate}}</span>
                    </div>
                    <div slot="cell(type)" slot-scope="data">
                      <span>{{ data.item.order_type.split('_')[0]}}</span>
                    </div>
                    <div slot="cell(delivery_country)" slot-scope="data">
                      <span>{{ data.item.country }}</span>
                    </div>
                    <div slot="cell(valid_from)" slot-scope="data">
                      <span v-if="!['tamaris','legero','tamaris_at'].includes(data.item.type)">
                        <template v-if="data.item.is_future">
                          <span style="color: #E08E0B;">{{data.item.valid_from | orderDateReverse(false)}}</span>
                        </template>
                        <template v-else>
                          {{data.item.valid_from | orderDateReverse(false)}}
                        </template>
                      </span>
                      <span v-else>
                        <template v-if="data.item.is_future">
                          <span style="color: #E08E0B;">{{data.item.valid_from | fieldNotInUse}}</span>
                        </template>
                        <template v-else>
                          {{data.item.valid_from | fieldNotInUse}}
                        </template>
                      </span>
                    </div>
                    <div slot="cell(anwr_trans_costs_step_1)" slot-scope="data">
                      <span v-if="!['tamaris','legero','tamaris_at'].includes(data.item.type)">
                        {{data.item.anwr_trans_costs_step_1 | currency}}
                      </span>
                      <span v-else >{{data.item.anwr_trans_costs_step_1 | fieldNotInUse}}</span>
                    </div>
                    <div slot="cell(anwr_trans_costs_step_2)" slot-scope="data">
                      <span v-if="!['tamaris','legero','tamaris_at'].includes(data.item.type)">
                        {{data.item.anwr_trans_costs_step_2 | currency}}
                      </span>
                      <span v-else >{{data.item.anwr_trans_costs_step_2 | fieldNotInUse}}</span>
                    </div>
                    <div slot="cell(anwr_return_costs_step_1)" slot-scope="data">
                      <span v-if="!['tamaris','legero','tamaris_at'].includes(data.item.type)">
                        {{data.item.anwr_return_costs_step_1 | currency}}
                      </span>
                      <span v-else >{{data.item.anwr_return_costs_step_1 | fieldNotInUse}}</span>
                    </div>
                    <div slot="cell(anwr_return_costs_step_2)" slot-scope="data">
                      <span v-if="!['tamaris','legero','tamaris_at'].includes(data.item.type)">
                        {{data.item.anwr_return_costs_step_2 | currency}}
                      </span>
                      <span v-else >{{data.item.anwr_return_costs_step_2 | fieldNotInUse}}</span>
                    </div>
                  </b-table>
                </template>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="col-xs-12 col-md-5 pull-right" v-if="sde1Active">
      <div class="box box-primary">
        <div class="box-header with-border">
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          </div>
          <h3 class="box-title"><i class="fa fa-truck mr-5"></i>{{'additional_fees_schoesde' | translate}}</h3>
        </div>
        <div class="box-body">
          <template v-if="ccFeesLoading">
            <img class="wt-loading-gif" src="/static/img/blabla.svg"/>
          </template>
          <template v-else>
            <div class="row mb-10">
              <div class="col-xs-12">
                <div class="input-group" style="width: 100%;">
                  <div class="input-group-addon">
                    <span>Click&Collect Disagio %</span>
                  </div>
                  <input type="text" class="form-control" :disabled="ccFeesLoading" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" data-vv-as="Disagio" data-vv-scope="ccFees" name="cc_disagio" v-model="ccFees.cc_disagio">
                </div>
                <span v-show="errors.has('ccFees.cc_disagio')" class="small text-danger">{{ errors.first('ccFees.cc_disagio') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="input-group" style="width: 100%;">
                  <div class="input-group-addon">
                    <span>{{'cost_per_month' | translate}} €</span>
                  </div>
                  <input type="text" class="form-control" v-validate="{required: true, regex: /^\d+([\,]\d+)*([\.]\d+)?$/}" :disabled="ccFeesLoading" v-model="ccFees.cost_per_month" name="cost_per_month" :data-vv-as="'cost_per_month' | translate" data-vv-scope="ccFees">
                </div>
                <span v-show="errors.has('ccFees.cost_per_month')" class="small text-danger">{{ errors.first('ccFees.cost_per_month') }}</span>
              </div>
            </div>
          </template>
        </div>
        <div class="box-footer" v-if="!ccFeesLoading">
          <div class="col-xs-12 text-right pull-right">
            <button @click="postCCFees" class="btn btn-flat btn-success">
              <i :class="['fa mr-5', ccFeesLoading ? 'fa-spinner fa-spin' : 'fa-save']"></i>{{'save' | translate | capitalize}}
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  import {sde1Active} from '@/sunset-helper'
  export default {
    data () {
      return {
        countries: [],
        Cfees: [],
        selectedCountry: '',
        twoHoursFuture: moment().add(3, 'hours').format('DD.MM.YYYY, HH:mm:ss a'),
        feesLoading: true,
        ccFeesLoading: true,
        selectedMpFee: 0,
        moment: moment,
        liveTime: moment().add(3, 'hours').format('DD.MM.YYYY HH:mm:ss'),
        fees: [],
        ccFees: {},
        fields: [
          {
            key: 'sales_channel'
          },
          {
            key: 'type'
          },
          {
            key: 'delivery_country'
          },
          {
            key: 'mp_costs_step_1'
          },
          {
            key: 'mp_costs_step_2'
          },
          {
            key: 'mp_costs_step_3'
          },
          {
            key: 'mp_costs_step_4'
          },
          {
            key: 'mp_costs_step_default'
          },
          {
            key: 'mp_return_costs'
          },
          {
            key: 'mp_payment_costs'
          },
          {
            key: 'valid_from'
          }
        ],
        anwrFields: [
          {
            key: 'sales_channel'
          },
          {
            key: 'type'
          },
          {
            key: 'delivery_country'
          },
          {
            key: 'anwr_trans_costs_step_1'
          },
          {
            key: 'anwr_trans_costs_step_2'
          },
          {
            key: 'anwr_return_costs_step_1'
          },
          {
            key: 'anwr_return_costs_step_2'
          },
          {
            key: 'valid_from'
          }
        ],
      }
    },
    methods: {
      getFees() {
        API.get(`/accounting/companies/fees/${this.$route.params.id}`)
          .then(response => {
            for (let key in response.data) {
              this.countries.push(key)
              for (let obj in response.data[key]) {
                let pushData=response.data[key][obj];
                pushData.type=pushData.type[0].toLowerCase()+pushData.type.substring(1);
                this.Cfees.push(pushData)
              }
            }
          })
      },
      postCCFees() {
        if (!this.sde1Active) return
        this.ccFeesLoading = true
        if (this.$validator.validateAll()) {
          this.ccFees.cc_disagio = this.ccFees.cc_disagio.toString().replace(',', '.')
          this.ccFees.cost_per_month = this.ccFees.cost_per_month.toString().replace(',', '.')
          API.put(`accounting/companies/${this.$route.params.id}/clickAndCollect/fees`, this.ccFees)
            .then(res => {
              this.ccFeesLoading = false
            })
        }
      },
      calcLiveTime() {
        this.liveTime = moment().add(2, 'hours').format('DD.MM.YYYY HH:mm:ss')
      },
      isEditable(fee) {
        let twoHs = moment().add(2, 'hours')
        let date = moment(fee.valid_from)
        return date.isAfter(twoHs)
      }
    },
    computed : {
      sde1Active,
      filteredFees() {
        return this.Cfees.filter(x => x.country === this.selectedCountry)
      },
      newFee () {
        return  {
          percent: 0,
          valid_from: moment(),
          return_fee: this.selectedMpFee === '4' ? 2.10 : 0
        }
      }
    },
    mounted() {
      this.getFees()
      setInterval(this.calcLiveTime, 1000)
      this.config = false
      this.type = 'barcode'
      if (this.sde1Active) {
        API.get(`accounting/companies/${this.$route.params.id}/clickAndCollect/fees`)
          .then(ccRes => {
            this.ccFees = ccRes.data
            this.feesLoading = false
            this.ccFeesLoading = false
          })
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .loading-gif {
    max-width: 345px;
    margin-left: 42%;
  }
  .italic {
    font-style: italic;
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
  .vdp-datepicker, .vdp-datepicker__calendar, .vdp-datepicker input {
    background-color: #202227 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Company/MarketplaceTax.vue